import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { setPatientCommonMedicationsOptions } from '../store/options.actions'
import { OptionsService } from '../services/options.service'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* setMedicationsCommon() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const medicationsCommonResponse: IOptionsResponse = yield call([
      optionsService,
      optionsService.getMedicationCommonOptions,
    ])
    const { entity } = medicationsCommonResponse
    yield put(setPatientCommonMedicationsOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`setMedicationsCommon() error: ${e}`))
  }
}

export function* setMedicationsCommonSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setMedicationsCommon)
}
